module.exports = __webpack_public_path__ + "static/media/seo.27f053ba.webp";